var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m17.28 12.48v3.84c0 .26496-.10656.504-.28128.67872s-.41376.28128-.67872.28128h-13.44c-.26496 0-.504-.10656-.67872-.28128s-.28128-.41376-.28128-.67872v-3.84c0-.52992-.43008-.96-.96-.96s-.96.43008-.96.96v3.84c0 .79488.32352 1.5168.84384 2.03616s1.24128.84384 2.03616.84384h13.44c.79488 0 1.5168-.32352 2.03616-.84384s.84384-1.24128.84384-2.03616v-3.84c0-.52992-.43008-.96-.96-.96s-.96.43008-.96.96zm-6.72-2.31744v-9.20256c0-.52992-.43008-.96-.96-.96s-.96.43008-.96.96v9.20256l-3.16128-3.16128c-.37536-.37536-.98304-.37536-1.35744 0s-.37536.98304 0 1.35744l4.8 4.8c.08832.08832.19392.15936.31104.20832s.24288.07296.36768.07296c.24576 0 .49152-.09408.67872-.28128l4.8-4.8c.37536-.37536.37536-.98304 0-1.35744s-.98304-.37536-1.35744 0z","fill":"#d6a444"}));
}

Download.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = Download;

Download.default = Download;
